import './css/app.scss';

import './js/vendor/stellarnav.js';
import './js/stellarnav-config.js';
import './js/main.js';

import './js/alpine.js';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
